import { CountryCode } from '~/core/enums';
import toolkitApi from '~/redux/toolkitApi';

type Location = {
    country: CountryCode;
};

const DEFAULT_COUNTRY = CountryCode.UnitedStates;

export default toolkitApi.injectEndpoints({
    endpoints: (build) => ({
        location: build.query({
            query: ({ baseUrl = window?.__SITE_SETTINGS__?.webAPIBaseURL }) => ({
                url: `${baseUrl}/location`,
                credentials: 'include',
            }),
            transformResponse: (data?: Location): CountryCode => data?.country || DEFAULT_COUNTRY,
        }),
    }),
});
